import { client } from '..';
import { BoardDirectorParams } from '../models/boardDirectoriesModels';

export const createBoardDirectory = async ({
  nonProfitOrgId,
  fullName,
  position,
  annualSalary,
  allowance
}: BoardDirectorParams): Promise<any> => {
  const { data } = await client.post('/board-directories', {
    fullName,
    position,
    annualSalary,
    allowance,
    nonProfitOrgId
  });
  return data;
};

export const createManyBoardDirectories = async (body: {
  boardDirectories: BoardDirectorParams[];
  npoId?: string;
}): Promise<any> => {
  const parsedNonProfitOrgId = body.npoId ? `?npoId=${body.npoId}` : '';

  const { data } = await client.post(`/board-directories/replace${parsedNonProfitOrgId}`, {
    boardDirectories: body.boardDirectories
  });
  return data;
};
